import {GridProps} from '@mui/material';
import {
   PtrnAccion,
   PtrnAccionPametroAuxiliar,
   PtrnBotonPosicion,
   PtrnCampoDistribucionGrid,
   PtrnColors,
   PtrnValor_o_Fn,
   PtrnAccionResultado,
   PtrnDataInput
} from '../../patronTypes';

export enum PtrnStepperTipoEjecucionPaso {
   avance = 'avance',
   retroceso = 'retroceso',
   detenido = 'detenido'
}

export type PtrnStepperFnRetornoPropValue<T = any> = (params: {
   accionResultadoActual: PtrnAccionResultado;
   paso: PtrnStep;
   pasoInxFiltrado: number;
}) => T;

export type PtrnStepperFnRetorno<T = any> = (
   data: PtrnDataInput,
   auxParam?: PtrnAccionPametroAuxiliar,
   stepperParam?: PtrnStepperParamsAdicionales
) => T;
export type PtrnStepIsDisabledValue = boolean | null;
export interface PtrnStep extends PtrnAccion {
   fn: PtrnStepperFnRetorno<PtrnAccionResultado | Promise<PtrnAccionResultado>>;
   color?: PtrnValor_o_Fn<PtrnColors>;
   colorExito?: PtrnValor_o_Fn<PtrnColors>;
   posicionIcono?: PtrnBotonPosicion;
   distribucion?: PtrnCampoDistribucionGrid;
   disableExito?: boolean;
   opcional?: boolean;
   hidden?: boolean;
   showEstadoMensaje?: boolean;
   defaultEstadoMensaje?: string;
   isDisabled?: PtrnStepperFnRetornoPropValue<PtrnStepIsDisabledValue> | PtrnStepIsDisabledValue;
}

export type UseStepperSencuencialSetPasosResultadosFn = (
   resultList: {step: PtrnStep; result: PtrnAccionResultado}[]
) => void;
export interface UseStepperSencuencialResultParcial {
   inicializarStepper: () => void;
   execNext: () => Promise<PtrnAccionResultado> | void;
   execPrev: () => Promise<PtrnAccionResultado> | void;
   execStepByInx: (stepInx: number) => Promise<PtrnAccionResultado> | void;
   setPasosResultados: UseStepperSencuencialSetPasosResultadosFn;
}
export interface PtrnStepperRef extends UseStepperSencuencialResultParcial {
   pasoActivoAnterior: number;
}

export interface PtrnStepperParamsAdicionales {
   pasoOrigen: number;
   pasoDestino: number;
   tipoEjecucion: PtrnStepperTipoEjecucionPaso;
}

export interface PtrnStepperButtonProps extends PtrnAccionPametroAuxiliar, GridProps {
   steps: PtrnStep[];
   activeStep: number;
   onActiveStepChange: (nuevoValor) => void;
   xs?: number;
   color?: PtrnColors;
   inicializarEnUltimoPaso?: boolean;
}
